module.exports = __webpack_public_path__ + "img/1fie-l-yetgu.202d87c3.jpg";